export default __webpack_public_path__ + "static/media/logo.6e04dcf9.svg";